/*甲方 */
import { $http, buildHeaders } from "./index";

//获取列表
export const customer_page = (params) => {
  return $http.get("/admin/Customer/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const customer_detail = (id) => {
  return $http.get("/admin/Customer/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const customer_add = (data) => {
  return $http.post("/admin/Customer/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const customer_edit = (data) => {
  return $http.post("/admin/Customer/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const customer_delete = (id) => {
  return $http.post(
    "/admin/Customer/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#region 联系人

//获取列表
export const customer_contact_page = (params) => {
  return $http.get("/admin/CustomerContact/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const customer_contact_detail = (id) => {
  return $http.get("/admin/CustomerContact/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const customer_contact_add = (data) => {
  return $http.post("/admin/CustomerContact/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const customer_contact_edit = (data) => {
  return $http.post("/admin/CustomerContact/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const customer_contact_delete = (id) => {
  return $http.post(
    "/admin/CustomerContact/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 开票信息

//获取列表
export const customer_invoice_page = (params) => {
  return $http.get("/admin/CustomerInvoice/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const customer_invoice_detail = (id) => {
  return $http.get("/admin/CustomerInvoice/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const customer_invoice_add = (data) => {
  return $http.post("/admin/CustomerInvoice/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const customer_invoice_edit = (data) => {
  return $http.post("/admin/CustomerInvoice/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const customer_invoice_delete = (id) => {
  return $http.post(
    "/admin/CustomerInvoice/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};

//#endregion

//#region 交易记录

//获取列表
export const customer_collected_plan_page = (params) => {
  return $http.get("/admin/CustomerCollectedPlan/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const customer_collected_plan_detail = (id) => {
  return $http.get("/admin/CustomerCollectedPlan/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//#endregion
